exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-549474f4]{overflow:auto;height:100%}.wrapper[data-v-549474f4]{display:flex;align-items:center;width:377px;height:130px;border:1px solid red;float:left}.left[data-v-549474f4]{display:inline-block;margin-right:20px}.left svg[data-v-549474f4]{width:100%;height:100%;max-width:300px;max-height:120px}.right[data-v-549474f4]{display:inline-block;-webkit-user-select:all;-ms-user-select:all;user-select:all;font-size:20px;margin-right:10px}", ""]);

// exports
